export default __webpack_public_path__ + "static/media/logo-ouestware.7ee1778f.svg";